// extracted by mini-css-extract-plugin
export var attachmentContainer = "_ny-0";
export var fileList = "_ny-2";
export var removeFileButton = "_ny-1";